import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.readonly
        ? _c(
            "div",
            { staticClass: "form-row" },
            [
              _c(
                VCol,
                { attrs: { sm: "2", lg: "2" } },
                [
                  _c(VSelect, {
                    attrs: {
                      label: _vm.$t("my_tasks.modals.datasource"),
                      dense: "",
                      outlined: "",
                      disabled: _vm.readonly,
                      items: _vm.filterDatasource,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.onChangeDatasource()
                      },
                    },
                    model: {
                      value: _vm.kdatasource,
                      callback: function ($$v) {
                        _vm.kdatasource = $$v
                      },
                      expression: "kdatasource",
                    },
                  }),
                ],
                1
              ),
              _vm.isUrldatasource
                ? _c(
                    VCol,
                    { attrs: { sm: "7", lg: "7" } },
                    [
                      !_vm.readonly
                        ? _c(
                            VBtn,
                            {
                              attrs: {
                                outlined: "",
                                dense: "",
                                small: "",
                                rounded: "",
                                color: "secondary",
                                disabled: _vm.readonly,
                              },
                              on: {
                                click: function ($event) {
                                  _vm.$refs.fileInput.$el
                                    .querySelector("input[type=file]")
                                    .click()
                                },
                              },
                            },
                            [
                              _vm._v(_vm._s(_vm.$t("my_tasks.modals.attach"))),
                              _c(VIcon, [_vm._v("mdi-paperclip")]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("b-form-file", {
                        ref: "fileInput",
                        staticStyle: { display: "none" },
                        attrs: { accept: _vm.METADATA_FILE_FORMAT.join(",") },
                        on: { change: _vm.onFileChange },
                        model: {
                          value: _vm.inputUploadFile,
                          callback: function ($$v) {
                            _vm.inputUploadFile = $$v
                          },
                          expression: "inputUploadFile",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isUrldatasource
                ? _c(
                    VCol,
                    { attrs: { sm: "2", lg: "2" } },
                    [
                      _c(VSelect, {
                        attrs: {
                          label: _vm.$t("my_tasks.modals.project"),
                          dense: "",
                          outlined: "",
                          disabled: _vm.readonly,
                          items: _vm.projectListDict,
                        },
                        model: {
                          value: _vm.new_table.project_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.new_table, "project_name", $$v)
                          },
                          expression: "new_table.project_name",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isUrldatasource
                ? _c(
                    VCol,
                    { attrs: { sm: "3", lg: "3" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          label: _vm.$t("my_tasks.tablas_tasks.datasource"),
                          dense: "",
                          outlined: "",
                          disabled: _vm.readonly,
                        },
                        model: {
                          value: _vm.new_table.dataset_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.new_table, "dataset_name", $$v)
                          },
                          expression: "new_table.dataset_name",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isUrldatasource
                ? _c(
                    VCol,
                    { attrs: { sm: "2", lg: "2" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          label: _vm.$t("my_tasks.tablas_tasks.table"),
                          dense: "",
                          outlined: "",
                          disabled: _vm.readonly,
                        },
                        model: {
                          value: _vm.new_table.table_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.new_table, "table_name", $$v)
                          },
                          expression: "new_table.table_name",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isUrldatasource
                ? _c(
                    VCol,
                    { attrs: { sm: "1", lg: "1", label: " " } },
                    [
                      _c(
                        VBtn,
                        {
                          attrs: {
                            outlined: "",
                            dense: "",
                            small: "",
                            rounded: "",
                            color: "secondary",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.odAddTable()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("btns.add_table")))]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { sm: "12", lg: "12" } },
            [
              _c(
                VSimpleTable,
                {
                  key: _vm.key_table,
                  staticClass: "table-mini bordered pb-2",
                  staticStyle: { "overflow-x": "scroll" },
                  attrs: { small: true, "sticky-header": "" },
                },
                [
                  _c("thead", [
                    _c("tr", [
                      _c(
                        "th",
                        {
                          staticStyle: {
                            "text-align": "left",
                            "vertical-align": "middle",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("my_tasks.tablas_tasks.datasource"))
                          ),
                        ]
                      ),
                      _c(
                        "th",
                        {
                          staticStyle: {
                            "text-align": "left",
                            "vertical-align": "middle",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("my_tasks.tablas_tasks.table")) + "s"
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _c(
                    "tbody",
                    _vm._l(_vm.item.datasources, function (ds, index) {
                      return _c("tr", { key: index }, [
                        _c(
                          "td",
                          {
                            staticStyle: {
                              "text-align": "left",
                              "vertical-align": "middle",
                            },
                          },
                          [_vm._v(_vm._s(_vm.getDatasourceName(ds)))]
                        ),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              "text-align": "left",
                              "vertical-align": "middle",
                            },
                          },
                          [
                            _c(
                              "ul",
                              {
                                staticClass: "m-0 pl-3",
                                staticStyle: { "list-style": "auto" },
                              },
                              [
                                ds.connectionDetails && ds.connectionDetails.url
                                  ? _c("li", { staticClass: "pb-2" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getNameUrl(
                                              ds.connectionDetails.url
                                            )
                                          )
                                        ),
                                      ]),
                                      _c(
                                        "i",
                                        {
                                          staticClass:
                                            "pointer material-icons h6",
                                          staticStyle: {
                                            position: "absolute",
                                            right: "20px",
                                          },
                                          attrs: {
                                            icon: "clipboard",
                                            title: "Copy Link",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.copyLinkDatasource(
                                                ds.connectionDetails.url
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("content_copy")]
                                      ),
                                    ])
                                  : _vm._e(),
                                ds.connectionDetails &&
                                ds.connectionDetails.database
                                  ? _c("li", { staticClass: "pb-2" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            ds.connectionDetails.database +
                                              " / " +
                                              _vm.getNameUrl(
                                                ds.connectionDetails.server
                                              )
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                ds.connectionDetails &&
                                ds.connectionDetails.path
                                  ? _c("li", { staticClass: "pb-2" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getNameFilePath(
                                              ds.connectionDetails.path
                                            )
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                ds.datasourceType == "Oracle"
                                  ? _c("li", { staticClass: "pb-2" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getNameUrl(
                                              ds.connectionDetails.server
                                            )
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm._l(_vm.filterTables(ds), function (table) {
                                  return _c("li", { staticClass: "pb-2" }, [
                                    table.type == "FILE"
                                      ? _c("div", [
                                          _c("span", [
                                            _vm._v(_vm._s(table.fileName)),
                                          ]),
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "material-icons h6 pointer",
                                              staticStyle: {
                                                position: "absolute",
                                                right: "20px",
                                              },
                                              attrs: { title: "Delete item" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteItem(table)
                                                },
                                              },
                                            },
                                            [_vm._v("delete")]
                                          ),
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "material-icons h6 pointer",
                                              staticStyle: {
                                                position: "absolute",
                                                right: "40px",
                                              },
                                              attrs: { title: "Download" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onClickLink(table)
                                                },
                                              },
                                            },
                                            [_vm._v("cloud_download")]
                                          ),
                                        ])
                                      : _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(table.project_name) + " /"
                                            ),
                                          ]),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(" " + table.dataset_name) +
                                                " /"
                                            ),
                                          ]),
                                          _c("span", [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: "javascript:void(0)",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onShowTable(
                                                      table
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(" " + table.table_name)
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "material-icons h6 pointer",
                                              staticStyle: {
                                                position: "absolute",
                                                right: "20px",
                                              },
                                              attrs: { title: "Delete item" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteItem(table)
                                                },
                                              },
                                            },
                                            [_vm._v("delete")]
                                          ),
                                        ]),
                                  ])
                                }),
                              ],
                              2
                            ),
                          ]
                        ),
                      ])
                    }),
                    0
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      !_vm.readonly
        ? _c(
            VRow,
            [
              _c(
                VCol,
                { staticClass: "text-right", attrs: { cols: "12" } },
                [
                  _c(
                    VBtn,
                    {
                      staticClass: "ml-2",
                      attrs: {
                        outlined: "",
                        small: "",
                        dense: "",
                        rounded: "",
                        type: "submit",
                        color: "secondary",
                      },
                      on: { click: _vm.onSubmit },
                    },
                    [
                      _c(
                        VIcon,
                        { staticClass: "md-16", attrs: { small: "" } },
                        [_vm._v("icon-send")]
                      ),
                      _vm._v(_vm._s(_vm.$t("my_tasks.modals.save_tables"))),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-modal",
        {
          ref: "preview-file-ds",
          attrs: {
            id: "preview-file-ds",
            "hide-footer": "",
            "no-close-on-backdrop": true,
            "no-close-on-esc": true,
          },
        },
        [
          _vm.currentFile.fileLink &&
          _vm.METADATA_IMAGE_FORMAT.filter(function (file) {
            return _vm.currentFile.fileName.toLowerCase().endsWith(file)
          }).length
            ? _c("b-col", [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.currentFile.fileLink,
                      download: _vm.currentFile.fileName,
                      target: "_blank",
                    },
                  },
                  [
                    _c("b-img", {
                      attrs: {
                        src: _vm.currentFile.fileLink,
                        fluid: "",
                        alt: _vm.currentFile.fileName,
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _c("b-col", [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.currentFile.fileLink,
                      download: _vm.currentFile.fileName,
                      target: "_blank",
                    },
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.currentFile.fileName))])]
                ),
              ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }